import "./App.css";
import Header from "./components/Header";
import TwoWaysOfBusiness from "./components/TwoWaysOfBusiness";
import FeautureSection from "./components/FeautureSection";
import HowItsWork from "./components/HowItsWork";
import FAQ from "./components/FAQ";
import GetStarted from "./components/GetStarted";

function HomePage() {


  return (
    <div className="min-h-screen bg-white">
      <Header />
      <TwoWaysOfBusiness />
      <FeautureSection />
      <HowItsWork />
      <GetStarted />
      <FAQ />
      {/* <Footer/>  */}
    </div>
  );
}

export default HomePage;
